import React, {useState} from "react";
import dayjs from "dayjs";
import {IconButton, InputAdornment, SxProps} from "@mui/material";
import CalendarIcon from "@mui/icons-material/CalendarTodayOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {DatePicker} from "@mui/x-date-pickers";

export interface Props {
    date: dayjs.Dayjs | null;
    onDateChange?: (date: dayjs.Dayjs | null) => void;
    sx?: SxProps;
    disableElevation?: boolean;
    disabled: boolean;
    maxDate?: dayjs.Dayjs;
}

export const CustomDatePicker: React.FC<Props> = (props) => {
    const {date, onDateChange, disabled, maxDate} = props;
    const [isOpen, setIsOpen] = useState(false);

    const onChange = (date: dayjs.Dayjs | null) => {
        setIsOpen(false);
        if (onDateChange) {
            onDateChange(date);
        }
    };

    return (
        <DatePicker
            open={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            maxDate={maxDate}
            value={date ? date : null}
            disabled={disabled}
            onChange={(newValue) => {
                onChange(newValue ? newValue : null);
            }}
            sx={{minWidth: "190px"}}
            slotProps={{
                textField: {
                    variant: "filled",
                    fullWidth: true,
                    InputProps: {
                        disableUnderline: true,
                        fullWidth: true,
                        startAdornment: (
                            <InputAdornment
                                position="start"
                                sx={{
                                    "&.MuiInputAdornment-root.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)":
                                        {
                                            margin: 0,
                                        },
                                }}
                            >
                                <CalendarIcon sx={{width: "1.1rem", margin: "0px"}} />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <IconButton onClick={() => setIsOpen(!isOpen)}>
                                {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        ),
                    },
                },
            }}
        />
    );
};
